import React, { useState } from 'react';
import DataEntry from '../add_agent';

const isEditting = true;

export default function DetailsPage(props){
    const [agentDetails] = useState(props);
    return(
        <div>
            <DataEntry 
                agentDetails={agentDetails.location.state} 
                isEditting={isEditting}
            />
        </div>
    );
}